import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button, Radio, Divider } from 'antd';
import dayjs from 'dayjs';
import { FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import moment from 'moment';
import { downloadFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;

const ApplicationMonthQualityReport = (props) => {

	//Variable declaration
	const columns = [
		{
				title: 'Date',
				dataIndex: 'createdOn',
				key: 'createdOn',
				render: (createdOn) => {
						 {return<span className='whitespace-nowrap'><p>{moment(createdOn).format('YYYY-MM-D')}</p><p>{moment(createdOn).format('h:mm a')}</p></span>}
				},
				sorter: (a, b) => moment(a.createdOn).unix() - moment(b.createdOn).unix(),
		},
		{
				title: 'App Status',
				dataIndex: 'appStatus',
				key: 'appStatus',
				sorter: (a, b) => {
						const nameA = `${a.appStatus}`.toLowerCase();
						const nameB = `${b.appStatus}`.toLowerCase();
						return nameA.localeCompare(nameB);
				}
		},
		{
				title: 'Ref',
				dataIndex: 'reference',
				key: 'reference',
				sorter: (a, b) => a.reference - b.reference,
		},
		{
				title: 'Job Title',
				dataIndex: 'title',
				key: 'title',
				sorter: (a, b) => {
						const nameA = `${a.title}`.toLowerCase();
						const nameB = `${b.title}`.toLowerCase();
						return nameA.localeCompare(nameB);
				}
		},
		{
				title: 'Location',
				dataIndex: 'place',
				key: 'place',
				sorter: (a, b) => {
						const nameA = `${a.place}`.toLowerCase();
						const nameB = `${b.place}`.toLowerCase();
						return nameA.localeCompare(nameB);
				}
		},
		{
				title: 'Supplier',
				dataIndex: 'supplierName',
				key: 'supplierName',
				sorter: (a, b) => {
						const nameA = `${a.supplierName}`.toLowerCase();
						const nameB = `${b.supplierName}`.toLowerCase();
						return nameA.localeCompare(nameB);
				},
		},
		{
				title: 'Candidate',
				dataIndex: 'userFirstName',
				key: 'userFirstName',
				render: (_, record) => (<>
						<div>{record.userFirstName+" "+record.userLastName}</div>
						<div>{record.email}</div><div>{record.telephone}
						</div> 
				</>),
				sorter: (a, b) => {
						const nameA = `${a.userFirstName}`.toLowerCase();
						const nameB = `${b.userFirstName}`.toLowerCase();
						return nameA.localeCompare(nameB);
				}
		},
];
	const [qualityData, setQualityData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [loader, setLoader] = useState(false);
	const [totalQualityCount, setTotalQualityCount] = useState(0);
	const [qualityReportTotal, setQualityReportTotal] = useState([]);
	const [supplierId,setSupplierId]=useState()
  const [type, setType] = useState(1);
	const [form] = Form.useForm();
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

	useEffect(() => {
		setType(props.location.state.quality)
		if(props){
		// const date1 = dayjs().startOf('month')
		// const date2 = dayjs().endOf('month')
		const date1 = dayjs(props.location.state.dateValue[0]);
		const date2 =dayjs(props.location.state.dateValue[1]);
		setSupplierId(props.location.state.supplierId)
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
		]);
		GetQualityReportData(1, 100,
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
			props.location.state.quality,
			props.location.state.supplierId
			);
	}
}
	, []);
	useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);


	//Functions
	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		//props.changeDate(dateStrings);
		setRangePickerValue([
			dayjs(dateStrings[0], constants.MonthFormat),
			dayjs(dateStrings[1], constants.MonthFormat),
		]);
		GetQualityReportData(currentPage, pageSize, dateStrings[0], dateStrings[1],type,supplierId);
	}, 500);

	//Function to Month report data
	const GetQualityReportData = async (currentPage, pazeSize, startDate, endDate,quality,supplierId) => {
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetApplicationMonthQualityReport + buyerId + "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage + "&quality="+quality + "&supplierId="+supplierId);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			//setQualityReportTotal(response.resultObj.data.pop());
			setQualityData(response.resultObj.data);
			setTotalQualityCount(response.resultObj.getCount);
			setLoader(false);
		} else {
			//setQualityData([]);
      setTotalQualityCount(0);
			setLoader(false);
			message.error(response.resultObj.message);
		}
	}

	const changeType = (radio) => {
		setType(radio.target.value);
		GetQualityReportData(currentPage, pageSize, rangePickerValue[0], rangePickerValue[1],radio.target.value,supplierId);
	}  

	//Function to download as excel
	const downloadFile = () => {
		setLoader(true)
		downloadFiles(WebLinks.DownloadApplicationMonthQualityReport+buyerId+ `&fromDate=${dayjs(rangePickerValue[0]).format(constants.MonthFormat)}&toDate=${dayjs(rangePickerValue[1]).format(constants.MonthFormat)}&quality=${type}&supplierId=${supplierId}`,"ApplicationMonthQualityReport.xlsx");
		setTimeout(() => {
				setLoader(false)
		}, 3000);
	};

	const getAplicationHeader=(type)=>{
		switch (type) {
			case 0:
					return "Applies"
			case 1:
				return "Qualities"
			case 2:
				return "Interviews"
			case 3:
				return "Hires"
		break;
			default:
		}
	};


	return (
		<>
			<Spin spinning={loader}>
				<div>
					<div className="flex justify-between items-center gap-1">
					<Space>
						<div className="uppercase font-bold text-xl">Applications Report - {getAplicationHeader(type)}</div>
					</Space>
				</div>
				<Divider className="my-3" />
					<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
						<Form form={form}>
							<Form.Item name="rangePicker" className='mb-0'>
								<RangePicker picker="month"
									placeholder={["From", "To"]}
									onChange={RangePickerChanged}
									//value={rangePickerValue}

									format={constants.MonthFormat} />
							</Form.Item>
						</Form>
            <Space wrap>
              <Radio.Group name="radiogroup" value={type} onChange={changeType}>
                <Radio value={0}>Applies</Radio>
                <Radio value={4}>Qualities</Radio>
                <Radio value={1}>Interviews</Radio>
								<Radio value={2}>Offers</Radio>
                <Radio value={3}>Hires</Radio>
              </Radio.Group>
          </Space>
          <Tooltip placement='right' title="Download as Excel">
              <Button
                  className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
                  icon={<FileExcelOutlined />}
                  onClick={()=>{downloadFile()}}
              >
                Download as Excel
              </Button>
          </Tooltip>
					</div>
					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={qualityData}
							scroll={{
								x: 1000,
							}}
							sortDirections={['descend', 'ascend', 'descend']}
							pagination={false}
						/>
					</div>
				</div>
			</Spin>
		</>
	);
};

export default ApplicationMonthQualityReport;